  <template>
  <div class="page">
    <div v-if="historyList.length == 0">
      暂无数据
    </div>
    <van-collapse v-if="historyList.length > 0" v-model="activeNames" accordion>
      <van-collapse-item
        v-for="(item, index) in historyList"
        :key="index"
        :title="item.name + '  ' + item.checkTime"
        :name="index + ''"
        class="updata history"
      >
        <van-cell-group>
          <van-field
            v-model="item.age"
            input-align="right"
            label="性别"
            required
          ></van-field>
          <van-field
            v-model="item.sex"
            input-align="right"
            label="体重"
            required
          ></van-field>
          <van-field
            v-model="item.weight"
            input-align="right"
            label="年龄"
            required
          ></van-field>
          <van-field
            v-model="item.history"
            input-align="right"
            label="戴眼镜史"
            required
          ></van-field>
          <van-field
            v-model="item.phone"
            input-align="right"
            label="电话"
            required
          ></van-field>
          <van-field
            v-model="item.site"
            input-align="right"
            label="地址"
            required
          ></van-field>
          <van-field
            v-model="item.checkTime"
            input-align="right"
            label="检查日期"
            required
          ></van-field>
        </van-cell-group>
        <van-cell-group>
          <div class="item">
            <div class="item-title">裸眼视力</div>
            <van-field
              v-model="item.vcvaLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.vcvaRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">矫正视力</div>
            <van-field
              v-model="item.cvaLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.cvaRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">电脑验光</div>
            <van-field
              v-model="item.optometryLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.optometryRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">眼压</div>
            <van-field
              v-model="item.iopLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.iopRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">眼轴长度</div>
            <van-field
              v-model="item.axialLengthLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.axialLengthRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">角膜曲率</div>
            <van-field
              v-model="item.cornealCurvatureLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.cornealCurvatureRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">角膜厚度</div>
            <van-field
              v-model="item.cornealThicknessLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.cornealThicknessRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">前房深度</div>
            <van-field
              v-model="item.chamberDepthLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.chamberDepthRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">晶体厚度</div>
            <van-field
              v-model="item.crystalThicknessLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.crystalThicknessRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">玻璃体厚度</div>
            <van-field
              v-model="item.vitreousThicknessLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.vitreousThicknessRight"
              label="右眼："
            ></van-field>
          </div>
          <div class="item">
            <div class="item-title">脉络膜厚度</div>
            <van-field
              v-model="item.choroidalThicknessLeft"
              label="左眼："
            ></van-field>
            <van-field
              v-model="item.choroidalThicknessRight"
              label="右眼："
            ></van-field>
          </div>
        </van-cell-group>
        <div class="imglist" v-if="item.photoList">
          <div class="imgitem" v-for="(item2, index) in item.photoList.split(',')" :key="index" @click="showimg(item.photoList.split(','))">
            <img :src="item2" alt="">
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import API from "../utils/api";
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
      historyList: [],
      activeNames: "0",
    };
  },
  watch: {},
  computed: {},
  methods: {
    getHistoryList() {
      this.$get(`${API.infoList}?phone=${sessionStorage.getItem("phone")}`)
        .then((res) => {
          if (res.code == 200) {
            this.historyList = res.data;
            for (let j = 0; j < this.historyList .length; j++) {
              if (this.historyList[j].photoList) {
                let imglist = this.historyList[j].photoList.split(",");
                let imgarr = []
                let imgobj = {}
                for (let i = 0; i < imglist.length; i++) {
                  imgobj.url = imglist[i];
                  imgarr.push(imgobj)
                }
                this.historyList[j].imglist = imgarr
              } 
            }
            console.log(this.historyList)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showimg(list){
      ImagePreview({
        images:list,
        closeable: true,
      });
    }
  },
  created() {},
  mounted() {
    this.getHistoryList();
  },
};
</script>
<style scoped>
</style>
<style>
.updata .item {
  display: flex;
}
.updata .item .item-title {
  width: 260px;
  padding: 10px 0 10px 16px;
  line-height: 24px;
}
.updata .item .van-cell__title {
  width: 3em;
}
.updata .item .van-cell::after {
  border: none;
}
.imglist{
  display: flex;
  flex-wrap: wrap;
}
.imglist .imgitem{
  width: 25%;
}
.imglist .imgitem img{
  width: 100%;
}
.history .van-collapse-item__title{
  background: #61dec3;
  color: #fff;
}
.history .van-collapse-item__title .van-cell__right-icon{
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/historyList.vue